export default __webpack_public_path__ + "static/media/additional-services.35ed01c5.svg";